export default {
    /**
     * @description 配置显示在浏览器标签的title
     */
    title: '杰出集团',

    /** 公司名称 */
    name: '山东杰出人才发展集团有限公司',

    /** 公司微信 */
    wechat: 'jiechu0933',

    /** 公司邮箱 */
    email: 'jiechugroup@163.com',

    /** 公司手机 */
    phone: '18279700225',

    /** 公司电话 */
    tel1: '0633-2270800',
    tel2: '0633-2270598',
    tel3: '0633-2183737',

    /** 公司地址 */
    address: '山东省日照市东港区日照人力资源服务产业园17楼',

    /** 公司网址 */
    website: 'https://杰出集团.com',

    /** 备案号 */
    keepOnRecordIcp: '鲁ICP备2023020065号-1',

    /** 百度地图相关信息 */
    BDMapInfo: {
        longitude: 119.5107,
        latitude: 35.434361,
        title: '人力资源服务产业园',
        address: '山东省日照市东港区日照人力资源服务产业园17楼'
    }
}


// WEBPACK FOOTER //
// ./src/config/index.js